import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import { resultsConfigSelector } from 'ctm-selectors';
import Dialog from '@material-ui/core/Dialog';
import { withRules, SimpleFlexbox, Text, ModalCloseIcon } from 'ctm-components';
import { useBrandContentFactory } from 'ctm-app/client/hooks/useBrandContentFactory';
import styles from './trusted_partners.css';

const theme = createTheme({
    overrides: {
        MuiPaper: {
            root: {
                padding: '2rem',
                // To fix the absolute-positioned close icon being cut off
                overflowY: 'unset !important'
            }
        }
    }
});

/**
 * This is the Trusted Partners Modal.
 * @param {Object} props React props.
 * @returns {TrustedPartnersModal} The TrustedPartners modal
 */
const _TrustedPartnersModal =  (props) => {
    const { trustedPartnersModalIsOpen, closeModal } = props;

    const brandContentFactory = useBrandContentFactory();
    const trustedPartnerContent = brandContentFactory.trustedPartnerContent();

    /**
   * Render top-right modal close icon button
   * @return {Node} the CloseIcon button
   */
    const renderCloseIcon = () => {
        const closeIconProps = { onClickFunction: closeModal };
        return React.createElement(ModalCloseIcon, closeIconProps);
    };

    return (
        <MuiThemeProvider theme={theme}>
            <Dialog fullWidth open={trustedPartnersModalIsOpen} onClose={closeModal} disableBackdropClick disableEscapeKeyDown>
                <SimpleFlexbox display="flex" column>
                    {/* Render title only if it's not empty */}
                    {trustedPartnerContent.title && (
                        <Text style={{ textTransform: 'capitalize' }} tagName="h3" color="brand_primary">{trustedPartnerContent.title}</Text>
                    )}

                    {/* Render description only if it's not empty */}
                    {trustedPartnerContent.description && (
                        <Text style={{ textTransform: 'capitalize' }} tagName="p">{trustedPartnerContent.description}</Text>
                    )}

                    {/* Render reasons list only if it's not empty */}
                    {trustedPartnerContent.reasons && trustedPartnerContent.reasons.length > 0 && (
                        <ul className={styles.ul}>
                            { trustedPartnerContent.reasons.map((item) => <li className={styles.li}>{item}</li>) }
                        </ul>
                    )}

                    {/* Render disclaimer only if it's not empty */}
                    {trustedPartnerContent.disclaimer && (
                        <Text size="small">{trustedPartnerContent.disclaimer}</Text>
                    )}
                </SimpleFlexbox>
                {renderCloseIcon()}
            </Dialog>
        </MuiThemeProvider>
    );
};

_TrustedPartnersModal.propTypes = {
    trustedPartnersModalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state) => {
    const trustedPartnersModal = resultsConfigSelector(state).getIn(['helpers', 'trustedPartners']);

    return {
        trustedPartnersModalIsOpen: trustedPartnersModal ? trustedPartnersModal.open : false
    };
};

const TrustedPartnersModal = withRules(connect(mapStateToProps)(_TrustedPartnersModal));

export { _TrustedPartnersModal, TrustedPartnersModal };
